var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgR = function SvgR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.225,
    height: 45.3
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 9V3.2a1.09 1.09 0 0 0-1-1.1H1A.987.987 0 0 0 0 3v41.2a1.09 1.09 0 0 0 1 1.1h8.6a.987.987 0 0 0 1-.9v-.2ZM27.5.4a4.253 4.253 0 0 0-1.1-.2 12.252 12.252 0 0 0-1.9-.2 14.506 14.506 0 0 0-7.6 2.1c-.3.2-.6.4-1 .7v9.7a8.341 8.341 0 0 1 1.2-.8 11.319 11.319 0 0 1 6-1.4 21.052 21.052 0 0 1 2.5.2c.4.1.9.2 1.3.3a1.115 1.115 0 0 0 1.3-.8V1.5a.892.892 0 0 0-.7-1.1",
    fill: "#fff"
  })));
};

export default SvgR;